import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { TaxCategoriesEnum } from '@gtpl/shared-models/common-models';
export class TaxesDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "Tax id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "Tax Name should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  @IsNotEmpty({message:"Tax id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  taxId?: number;
  @ApiProperty()
  @MaxLength(20, { message: "Tax Name allows maximum 20 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Taxe name should be only alpha numeric" })
  taxName: string;
  @ApiProperty()
  @MaxLength(20, { message: "Tax Percentage allows maximum 20 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Taxe Percentage should be only alpha numeric" })
  taxPercentage: number;

  @ApiProperty()
  taxCategory:TaxCategoriesEnum
  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  
}

